var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("webList.tradeType.tableField"),
        visible: _vm.visibleValue,
        width: "530px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleValue = $event
        },
        close: _vm.closeTableSetting,
      },
    },
    [
      _c(
        "div",
        { staticClass: "container-header" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("webList.tradeType.fixedField"))),
                  ]),
                  _vm._l(_vm.tableSetting_disabled, function (item) {
                    return _c(
                      "el-checkbox",
                      {
                        key: item.prop,
                        staticClass: "normal-checkbox",
                        staticStyle: { "margin-top": "10px", display: "block" },
                        attrs: { size: "small", disabled: "" },
                        model: {
                          value: item.value,
                          callback: function ($$v) {
                            _vm.$set(item, "value", $$v)
                          },
                          expression: "item.value",
                        },
                      },
                      [_vm._v(_vm._s(_vm.lang === "zh" ? item.zh : item.en))]
                    )
                  }),
                ],
                2
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("webList.tradeType.optionalField"))),
                  ]),
                  _vm._l(_vm.tableSetting_active, function (item) {
                    return _c(
                      "el-checkbox",
                      {
                        key: item.prop,
                        staticClass: "normal-checkbox",
                        staticStyle: { "margin-top": "10px", display: "block" },
                        attrs: { size: "small" },
                        on: { change: _vm.change },
                        model: {
                          value: item.value,
                          callback: function ($$v) {
                            _vm.$set(item, "value", $$v)
                          },
                          expression: "item.value",
                        },
                      },
                      [_vm._v(_vm._s(_vm.lang === "zh" ? item.zh : item.en))]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ac", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              staticClass: "foot-button",
              attrs: { round: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("hide")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("webList.addWebDialog.cancel")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "foot-button",
              attrs: { round: "", type: "primary", loading: _vm.saveLoading },
              on: { click: _vm.saveTableSetting },
            },
            [_vm._v(_vm._s(_vm.$t("webList.tradeType.saveSeting")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }